import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SetCursorPositionRightCommand from './setcursorpositionrightcommand';

export default class SetCursorPositionRightEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'setcursorpositionright', new SetCursorPositionRightCommand( editor, 'setcursorpositionright' ) );
  }
}